import {combineEpics} from 'redux-observable';
import books from 'epics/books';

export default combineEpics(books);
